/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import * as React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDProgress from "components/MDProgress";
import { useTranslation } from "react-i18next";
import axios from "axios";
import config from "../../../../config/config.json";
import authHeader from "../../../../helpers/auth-headers";
import authService from "../../../../helpers/auth.service";

// patios: lista já filtrada (somente pátios exibidos no dashboard)
export default function data(patios) {
  const { t } = useTranslation("common");
  const [period, setPeriod] = React.useState({ am: 0, pm: 0 });
  const { API_URL } = config;
  const user = authService.getCurrentUser();

  const Company = ({ name }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDTypography variant="button" fontWeight="medium" ml={1} lineHeight={1}>
        {name}
      </MDTypography>
    </MDBox>
  );

  React.useEffect(() => {
    axios.get(`${API_URL}accounts/${user.accountsIdaccounts}`, { headers: authHeader() }).then(
      (response) => {
        setPeriod({ am: response.data.monitoringByAM, pm: response.data.monitoringByPM });
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);

  const rows = patios.map((p) => {
    const done = p.totalAM + p.totalPM;
    const expected = period.am + period.pm;
    return {
      companies: <Company name={p.name} />,
      monitoringAM: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {`${p.totalAM}/${period.am}`}
        </MDTypography>
      ),
      monitoringPM: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {`${p.totalPM}/${period.pm}`}
        </MDTypography>
      ),
      completion: (
        <MDBox width="8rem" textAlign="left">
          <MDProgress
            value={expected > 0 ? Math.min((done * 100) / expected, 100) : 0}
            color="info"
            variant="gradient"
            label={false}
          />
        </MDBox>
      ),
    };
  });

  return {
    columns: [
      { Header: t("dashboard.dash_dock"), accessor: "companies", align: "center" },
      { Header: t("dashboard.dash_monitoringAM"), accessor: "monitoringAM", align: "center" },
      { Header: t("dashboard.dash_monitoringPM"), accessor: "monitoringPM", align: "center" },
      { Header: t("dashboard.dash_progress"), accessor: "completion", align: "center" },
    ],

    rows,
  };
}
